import { render, staticRenderFns } from "./HeroLanding.vue?vue&type=template&id=015ac034&scoped=true&"
import script from "./HeroLanding.vue?vue&type=script&lang=ts&"
export * from "./HeroLanding.vue?vue&type=script&lang=ts&"
import style0 from "./HeroLanding.vue?vue&type=style&index=0&id=015ac034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ac034",
  null
  
)

export default component.exports